import { distinctUntilChanged, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Navigate, RouterState } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { routeNames } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private navigateTimeout;
  private navigateParams;

  constructor(private store: Store) {}

  get routerParamsWatch() {
    return this.store.select(RouterState.state).pipe(
      map((v: any) => v?.params),
      distinctUntilChanged()
    );
  }

  navigatePreserve(params = []) {
    clearTimeout(this.navigateTimeout);
    // fire single action if multiple triggered
    this.navigateTimeout = setTimeout(() => {
      this.store.dispatch(
        new Navigate([routeNames.editorBase, ...params], null, { queryParamsHandling: 'preserve' })
      );
    }, 100);
  }

  navigateBaseFirstCurrent(params?: any, base = false) {
    // combine all params
    this.navigateParams = { ...(this.navigateParams || {}), ...(params || {}) };
    clearTimeout(this.navigateTimeout);
    // fire single action if multiple triggered
    this.navigateTimeout = setTimeout(() => {
      const params = (this.store.selectSnapshot(RouterState.state) as any)?.params;
      const path = base || !params // navigate to base if not first page navigation (manual navigation)
        ? [routeNames.editorBase]
        : [routeNames.editorBase, ...Object.values(params)];
      this.store.dispatch(
        new Navigate(path, this.navigateParams, { queryParamsHandling: 'merge' })
      );
      // unset combined params
      this.navigateParams = {};
    }, 100);
  }
}
